import { forwardRef } from 'react'
import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from './cn'

export type CardPadding = 'md' | 'sm' | 'none'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** 内側パディング。既定は md（p-6） */
  padding?: CardPadding
  /** hover で持ち上げる装飾（影を強め 2px 上げる） */
  interactive?: boolean
  children?: ReactNode
}

// 背景・角丸・影は variant が確定（利用側 className での上書き対象外）。
const BASE = 'bg-card rounded-panel shadow-card'

const PADDING: Record<CardPadding, string> = {
  md: 'p-6',
  sm: 'p-4',
  none: '',
}

const INTERACTIVE = 'transition-all hover:shadow-lg hover:-translate-y-0.5'

/** 情報グルーピング容器。原則は非インタラクティブ（クリック責務は内部要素に委ねる）。 */
export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { padding = 'md', interactive = false, className, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(BASE, PADDING[padding], interactive && INTERACTIVE, className)}
      {...rest}
    >
      {children}
    </div>
  )
})
